import { useEffect, useState } from "react";
import useErrorHandler from "../FormErrorHandler";
import {
  FormInputRow,
  FormSection,
  FormHeader,
  RadioInput,
} from "../../FormInput/FormInput";
import PassengerInfo from "../PassengerInfo";

const GettingStarted = ({ formData, handleInputChange, validateForm }) => {
  const { error, addError, clearError, hasError } = useErrorHandler();
  const [passengersInfo, setPassengersInfo] = useState(
    formData.passengersInvehiclesLists || []
  );

  const addItem = () => {
    setPassengersInfo((prev) => [
      ...prev,
      { id: Date.now(), validate: () => false },
    ]);
  };

  if(passengersInfo.length == 0)
    addItem()

  const validate = async (formData) => {
    clearError();

    let hasValidationError = false;
    let hasSetFocused = false;
    for (const person of passengersInfo) {
      if (typeof person.validate === "function") {
        const isValid = await person.validate(person);
        if (!isValid) {
          hasValidationError = true;
          if(!hasSetFocused){
            person.setIsFocused(true)
            hasSetFocused = true
          }
        }
      } else {
        hasValidationError = true;
      }
    }

    return !hasError() && !hasValidationError;
  };

  validateForm.current = validate;

  useEffect(() => {
    if(passengersInfo.length == 0)
        addItem()
  }, [])

  useEffect(() => {
    handleInputChange(
      "passengersInvehiclesLists", passengersInfo
    );
  }, [passengersInfo])

  return (
    <div>
      <FormHeader>ADDITIONAL INFORMATION</FormHeader>
        {passengersInfo.map((data, index) => {
          return (
            <PassengerInfo
              key={data.id}
              id={data.id}
              index={index}
              data={data}
              updateInfo={setPassengersInfo}
              canRemove={passengersInfo.length > 1}
            />
          );
        })}
        <div style={{ display: "flex", justifyContent: "center" }}>
          <button
            className="btn btn-primary btn-sm m-1 px-4 fw-bold text-wrap"
            style={{ borderRadius: "20px" }}
            onClick={addItem}
          >
            + Add Another Passenger Involved in This Loss
          </button>
        </div>
    </div>
  );
};

export default GettingStarted;
